import { Box, Page, Stack, Typography } from "@fideus-ui/core";
import { useEffect } from "react";
import { MaintenancePageLoadedEvent, useTrack } from "../_app/analytics";
import { useTranslation } from "../_app/i18n";
import { translations } from "./translations";
import underConstruction from "./under-construction.svg?url";

interface MaintenancePageProps {
  message: string;
}

export function MaintenancePage({ message }: MaintenancePageProps) {
  const t = useTranslation(translations);
  const track = useTrack();

  useEffect(() => {
    track(new MaintenancePageLoadedEvent());
  }, [track]);

  return (
    <Page>
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems="center"
        justifyContent="center"
        gap={6}
      >
        <Stack>
          <Typography variant="h3" component="h1" gutterBottom>
            {t("title")}
          </Typography>

          <Typography>{message}</Typography>
        </Stack>
        <Box
          component="img"
          src={underConstruction}
          alt={t("imageAlt")}
          sx={{
            width: "100%",
            maxWidth: 400,
          }}
        />
      </Stack>
    </Page>
  );
}
